<script setup>
import { VueFinalModal } from 'vue-final-modal';
import VfmHeader from 'resources/js/components/VfmHeader.vue';
import { PrimeTvChannels } from '../../constants/prime/tv-channels';
import {PrimeTvStreams} from "../../constants/prime/tv-streams";

const emit = defineEmits(['close']);
</script>

<template>
    <VueFinalModal
        :esc-to-close="true"
        :click-to-close="true"
        class="prime-modal prime-streams-modal"
    >
        <div class="prime-streams-modal__cont">
            <VfmHeader
                title="Список онлайн-кинотеатров"
                class="prime-modal__header prime-streams-modal__header"
                @close="emit('close')"
            />

            <ul class="prime-streams-modal__body">
                <li v-for="item in PrimeTvStreams" class="prime-streams-modal__item">
                    <img :src="`/img/prime/${item.img}`" :alt="item.name" class="prime-streams-modal__img">
                    {{ item.name }}
                </li>
            </ul>
        </div>
    </VueFinalModal>
</template>

<style lang="scss">
@import 'resources/sass/variables';

.prime-streams-modal {
    .vfm__content {
        max-width: 800px;
        background: #0F0E0E;
    }

    &__header {
        padding-left: 44px !important;
        background: #0F0E0E;

        .vfm__title {
            width: 100%;
            text-align: center;
            color: #DDAA4C;
        }
    }

    &__cont {
        color: white;
        font-size: 15px;
    }

    &__body {
        padding: 16px 36px 36px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 16px;

        @media screen and (max-width: $mobile-max-width) {
            padding: 16px 24px 24px;
            grid-template-columns: 1fr;
        }
    }

    &__item {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: $font-weight-semibold;
    }

    &__img {
        display: block;
        margin-right: 16px;
        width: 48px;
        height: 48px;
    }
}
</style>
